import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { removeTag } from '../../api/tag.ts';

export default function useRemoveTag(): UseMutationResult<
  Awaited<ReturnType<typeof removeTag>>,
  Error
> {
  return useMutation({
    mutationFn: removeTag,
  });
}
